/*
  ClickLease estimated-monthly-payment widget.

  Ported from the Honey theme's inline <script> in layout/theme.liquid and re-pointed
  at Dawn's markup. Behaviour is unchanged: for any price between $500 and $30,000 it
  asks the ClickLease API for an estimated monthly payment and renders the branded
  button beneath the price, on both product pages and product cards.

  Differences from the Honey original, all deliberate:
    - Dawn class names (.price / .card-wrapper / .product__info-container) instead of
      Honey's (.price__last / .product-card-wrapper / .product-single__meta).
    - The click handler is bound in JS rather than injected as an inline onClick
      attribute, so it survives a Content-Security-Policy.
    - A MutationObserver replaces the original's permanent setInterval polling, so it
      still catches cards added by pagination or filtering without running forever.
*/
(function () {
  'use strict';

  var SVG_TEMPLATE = `<svg style="cursor:pointer"   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="31" viewBox="0 0 450 31">

    <defs>
    
    <clipPath id="clip-Web_1920_1">
    
    <rect width="455" height="31"/>
    
    </clipPath>
    
    </defs>
    
    <g id="Web_1920_1" data-name="Web 1920 – 1" clip-path="url(#clip-Web_1920_1)">
    
    <g id="Blue_Button" data-name="Blue Button" transform="translate(-172.688 5.325)">
    
    <path id="Path_1185" data-name="Path 1185" d="M534.473,0H452.306a12.321,12.321,0,1,0,0,24.642h82.167a12.321,12.321,0,1,0,0-24.642Z" transform="translate(76.464 -1.325)" fill="#20b6f1"/>
    
    <path id="Path_1186" data-name="Path 1186" d="M463.7,16.229h2.033L462.246,7.6h-1.762L457.1,16.229h1.984l.591-1.626H463.1Zm-2.316-6.345,1.134,3.093H460.25ZM470.141,7.6h-3.314v8.625h1.86V13.543h1.454a2.97,2.97,0,1,0,0-5.939Zm-.086,4.214h-1.368V9.342h1.368a1.238,1.238,0,1,1,0,2.476ZM477.8,7.6h-3.314v8.625h1.86V13.543H477.8a2.97,2.97,0,1,0,0-5.939Zm-.086,4.214h-1.368V9.342h1.368a1.238,1.238,0,0,1,0,2.476Zm6.3,2.686V7.6h-1.86v8.625h5.175V14.5Zm10.689-6.9h-2l-2,3.462L488.73,7.6h-1.984l3.006,5.138v3.487h1.91v-3.47Zm9.308,0v5.261L500.231,7.6h-1.676v8.625h1.823v-5.38l3.906,5.384h1.565V7.6Zm7.9,8.822a4.438,4.438,0,0,0,4.583-4.509,4.6,4.6,0,1,0-4.583,4.509Zm0-1.762a2.681,2.681,0,0,1-2.711-2.748,2.67,2.67,0,0,1,2.711-2.735,2.643,2.643,0,0,1,2.686,2.735,2.653,2.653,0,0,1-2.692,2.753ZM527.455,7.6l-1.663,5.729L523.475,7.7h-.628l-2.267,5.643L518.88,7.6h-1.971l2.711,8.625h1.663l1.873-4.83,1.922,4.83h1.663L529.4,7.6Z" transform="translate(76.603 -0.827)" fill="#fff"/>
    
    <path id="Path_1187" data-name="Path 1187" d="M369.962,17.126l-3.183-4.759v4.759h-2.69V3.594h2.689V11.6l2.991-4.424h3.1L369.5,11.915l3.724,5.211Z" transform="translate(84.713 0.096)" fill="#20b6f1"/>
    
    <path id="Path_1188" data-name="Path 1188" d="M378.633,3.593h-2.69V17.125h2.69Z" transform="translate(85.03 0.096)" fill="#636363"/>
    
    <path id="Path_1189" data-name="Path 1189" d="M390.694,12.821h-7.529a2.319,2.319,0,0,0,2.431,2.1,2.361,2.361,0,0,0,2.111-1.154h2.827a5.374,5.374,0,1,1,.209-1.735,6.332,6.332,0,0,1-.049.789Zm-7.457-1.837h4.817a2.446,2.446,0,0,0-2.464-1.876,2.333,2.333,0,0,0-2.361,1.876" transform="translate(85.15 0.182)" fill="#636363"/>
    
    <path id="Path_1190" data-name="Path 1190" d="M402.486,7.078v9.947H400.38l-.232-.889a4.837,4.837,0,0,1-3.223,1.186,5.116,5.116,0,0,1-5.218-5.27,5.1,5.1,0,0,1,5.218-5.236,4.854,4.854,0,0,1,3.268,1.217l.288-.95Zm-2.637,4.973a2.711,2.711,0,1,0-.206,1.037,2.711,2.711,0,0,0,.206-1.037Z" transform="translate(85.451 0.182)" fill="#636363"/>
    
    <path id="Path_1191" data-name="Path 1191" d="M408.273,17.321c-2.5,0-4.165-1.425-4.179-3.557h2.623c.013.886.691,1.328,1.656,1.328.746,0,1.415-.338,1.415-1s-.862-.886-1.914-1.062c-1.589-.264-3.611-.69-3.611-3.035,0-1.882,1.6-3.183,4-3.183s3.978,1.335,3.988,3.325H409.7c-.009-.791-.564-1.181-1.5-1.181-.838,0-1.335.383-1.335.953,0,.663.848.821,1.882,1,1.622.292,3.7.635,3.7,3.058,0,2.03-1.659,3.351-4.172,3.351Z" transform="translate(85.782 0.182)" fill="#636363"/>
    
    <path id="Path_1192" data-name="Path 1192" d="M423.758,12.82h-7.529a2.319,2.319,0,0,0,2.431,2.1,2.361,2.361,0,0,0,2.111-1.154H423.6a5.373,5.373,0,1,1,.209-1.735,6.334,6.334,0,0,1-.052.789ZM416.3,10.983h4.819a2.446,2.446,0,0,0-2.464-1.876,2.332,2.332,0,0,0-2.361,1.876" transform="translate(86.034 0.182)" fill="#636363"/>
    
    <path id="Path_1193" data-name="Path 1193" d="M316.966,16.08a5.873,5.873,0,1,1,0-7.367l6.058-2.7a12.4,12.4,0,1,0,0,12.768Z" transform="translate(83)" fill="#20b6f1"/>
    
    <path id="Path_1194" data-name="Path 1194" d="M326.7,6.751l-6.126,2.733-6.129,2.731,6.129,2.733,6.126,2.734-1.622-5.463Z" transform="translate(83.386 0.18)" fill="#636363"/>
    
    <path id="Path_1195" data-name="Path 1195" d="M359.809,13.627a2.49,2.49,0,1,1,0-3.122l2.567-1.145a5.256,5.256,0,1,0,0,5.412Z" transform="translate(84.406 0.182)" fill="#20b6f1"/>
    
    <path id="Path_1196" data-name="Path 1196" d="M345.686,3.593H343V17.125h2.69Z" transform="translate(84.149 0.096)" fill="#20b6f1"/>
    
    <path id="Path_1197" data-name="Path 1197" d="M348.127,7.185h2.69v9.948h-2.69Zm0-3.827h2.68v2.5h-2.68Z" transform="translate(84.286 0.09)" fill="#20b6f1"/>
    
    <path id="Path_1198" data-name="Path 1198" d="M338.954,13.627a2.49,2.49,0,1,1,0-3.122l2.567-1.145a5.256,5.256,0,1,0,0,5.412Z" transform="translate(83.849 0.182)" fill="#20b6f1"/>
    
    <path id="Path_1199" data-name="Path 1199" d="M134.144,16.522c2.1,0,3.516-1.068,3.516-2.727,0-2.168-1.807-2.464-3.335-2.711-1.183-.181-2.2-.361-2.2-1.3,0-.772.756-1.265,1.955-1.265,1.249,0,2,.526,2.053,1.495h1.314c-.049-1.676-1.331-2.743-3.335-2.743s-3.351,1.035-3.351,2.563c0,2,1.708,2.316,3.22,2.579,1.2.2,2.3.394,2.3,1.446,0,.854-.871,1.38-2.086,1.38-1.249,0-2.152-.575-2.218-1.626H130.6c.082,1.792,1.446,2.91,3.548,2.91Zm9.913-.2h1.4V4.3h-1.4Zm8.212.2a4.552,4.552,0,0,0,4.7-4.633,4.707,4.707,0,1,0-9.413,0,4.556,4.556,0,0,0,4.717,4.634Zm0-1.347a3.176,3.176,0,0,1-3.286-3.286,3.277,3.277,0,0,1,6.554.016,3.167,3.167,0,0,1-3.264,3.271Zm17.5-7.721-2.251,6.6L164.78,7.6h-.509l-2.711,6.39-2.218-6.538H157.9l2.99,8.871h1.134l2.513-6.029,2.5,6.029h1.134l3.023-8.871Zm14.748,0-.181,1.363a4.627,4.627,0,1,0-.018,6.176l.148,1.331h1.15V7.455Zm-3.581,7.721a3.2,3.2,0,0,1-3.269-3.286,3.2,3.2,0,0,1,3.269-3.269,3.164,3.164,0,0,1,3.253,3.269,3.168,3.168,0,0,1-3.249,3.287Zm10.3,1.347c2.1,0,3.516-1.068,3.516-2.727,0-2.168-1.807-2.464-3.335-2.711-1.183-.181-2.2-.361-2.2-1.3,0-.772.756-1.265,1.955-1.265,1.249,0,2,.526,2.053,1.495h1.314c-.049-1.676-1.331-2.743-3.335-2.743s-3.351,1.035-3.351,2.563c0,2,1.708,2.316,3.22,2.579,1.2.2,2.3.394,2.3,1.446,0,.854-.871,1.38-2.086,1.38-1.249,0-2.152-.575-2.218-1.626H187.7c.078,1.792,1.442,2.91,3.545,2.91Zm50.21.936h1.478L247.7,3.823h-1.446ZM259.371,7.274a3.578,3.578,0,0,0-3.006,1.676,2.9,2.9,0,0,0-2.727-1.676A3.6,3.6,0,0,0,250.8,8.687l-.23-1.232h-1v8.871h1.4V11.414a2.639,2.639,0,0,1,2.366-2.875c1.281,0,2.021.953,2.021,2.563v5.224h1.38V11.414A2.639,2.639,0,0,1,259.1,8.539c1.265,0,2,.953,2,2.563v5.224h1.4V10.658a3.1,3.1,0,0,0-3.132-3.384Zm9.81,9.249a4.552,4.552,0,0,0,4.7-4.633,4.707,4.707,0,1,0-9.414,0,4.556,4.556,0,0,0,4.714,4.633Zm0-1.347A3.176,3.176,0,0,1,265.9,11.89a3.277,3.277,0,1,1,6.555.016,3.168,3.168,0,0,1-3.274,3.27Zm21.672-7.721-2.251,6.6L285.859,7.6h-.509l-2.711,6.39-2.218-6.538h-1.446l2.99,8.871H283.1l2.513-6.029,2.5,6.029h1.134l3.023-8.871Zm3.082-1.528h1.511V4.333h-1.511Zm.049,10.4h1.4V7.455h-1.4v8.872Zm7.883-1.281A1.678,1.678,0,0,1,300,13.188V8.719h2.793V7.455H300V5.582h-.214l-2.743,2.891v.246H298.6v4.518a2.857,2.857,0,0,0,3.088,3.088h1.15V15.044Zm7.269-7.77a3.782,3.782,0,0,0-3.039,1.4V4.3h-1.4V16.325h1.4V11.5a2.793,2.793,0,0,1,2.694-2.957c1.528,0,2.382,1.019,2.382,2.809V16.33h1.4V11.019c0-2.3-1.317-3.745-3.436-3.745Z" transform="translate(56.898 0.736)" fill="#101112"/>
    
    <text id="_1" data-name="1" transform="translate(248 42.7)" fill="#009fdf" font-size="17" font-family="ArialMT, Arial"><tspan x="10" y="-25.3"> $${monthly}</tspan></text>
    
    <text id="A" transform="translate(174.688 16.675)" font-size="18" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">A</tspan></text>
    
    </g>
    
    </g>
    
    </svg>`;

  var PARTNER_URL = 'https://www.clicklease.com/partner/%20j4-trailer';
  var API = 'https://app.clicklease.com/api/estimatedPaymentAmount/';
  var MIN = 500;
  var MAX = 30000;
  var EXCLUDED = ['/kayaks', '/hunting'];

  function excluded() {
    var href = window.location.href;
    for (var i = 0; i < EXCLUDED.length; i++) {
      if (href.indexOf(EXCLUDED[i]) !== -1) return true;
    }
    return false;
  }

  function buttonSvg(monthly) {
    return SVG_TEMPLATE.replace('${monthly}', monthly);
  }

  function amountFrom(priceEl) {
    if (!priceEl) return NaN;
    var node =
      priceEl.querySelector('.price-item--sale') ||
      priceEl.querySelector('.price-item--regular') ||
      priceEl.querySelector('.price-item') ||
      priceEl;
    var text = (node.textContent || '').replace(/[^0-9.]+/g, '');
    return Number(text);
  }

  function render(priceEl) {
    if (!priceEl || priceEl.dataset.clkDone === '1') return;

    var amount = amountFrom(priceEl);
    if (!isFinite(amount) || amount < MIN || amount > MAX) return;

    priceEl.dataset.clkDone = '1';

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4 || xhr.status !== 200) return;

      var monthly;
      try {
        monthly = JSON.parse(xhr.response).object;
      } catch (e) {
        return;
      }
      if (monthly === undefined || monthly === null) return;

      var holder = document.createElement('div');
      holder.className = 'ClkButton';
      holder.setAttribute('style', 'width: 100%; max-width: 500px');
      holder.innerHTML = buttonSvg(monthly);
      holder.addEventListener('click', function () {
        window.open(PARTNER_URL, '_blank', 'noopener');
      });
      priceEl.insertAdjacentElement('afterend', holder);
    };
    xhr.open('GET', API + amount, true);
    xhr.send();
  }

  function scan(root) {
    if (excluded()) return;
    var scope = root || document;

    // Product page: the price inside the main info column.
    var main = scope.querySelector
      ? scope.querySelector('.product__info-container .price')
      : null;
    if (main) render(main);

    // Product cards, in collections and any featured-collection row.
    var cards = scope.querySelectorAll ? scope.querySelectorAll('.j4-card__price .price') : [];
    for (var i = 0; i < cards.length; i++) render(cards[i]);
  }

  function boot() {
    scan(document);

    // Cards can arrive later from filtering, pagination or a quick-add drawer.
    var grid = document.getElementById('ProductGridContainer') || document.body;
    if (!window.MutationObserver || !grid) return;

    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        scan(document);
      }, 200);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Re-price the product-page widget when the shopper switches variant.
  document.addEventListener('variant:change', function () {
    var el = document.querySelector('.product__info-container .price');
    var existing = document.querySelector('.product__info-container .ClkButton');
    if (existing) existing.remove();
    if (el) {
      delete el.dataset.clkDone;
      render(el);
    }
  });
})();
